import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// The header's tertiary "View {Page}" link: Button/Medium (Semibold 16/20) in the teal tertiary-action
// color, 4px before the icon. Shared by the PageHeader action slot and PageHeaderLink, so pages with
// their own header row render the same link (MAX-4484).
export const pageHeaderLinkStyle = (theme: Theme): CSSObject => ({
	display: "inline-flex",
	alignItems: "center",
	gap: 4,
	whiteSpace: "nowrap",
	color: theme.palette.custom.tertiaryAction,
	fontSize: 16,
	fontWeight: 590,
	lineHeight: "20px",
	textDecoration: "none",
	"&:hover": {
		textDecoration: "none",
	},
});

// Shared Page Header (Figma "Page Header" component): a title row (title + optional right-aligned
// action) with the description full-width below, separated by a 16px (spacing/md) gap.
export const styles = (theme: Theme) =>
	({
		root: {
			display: "flex",
			flexDirection: "column",
			gap: 16,
			width: "100%",
			marginBottom: 16,
		},
		titleRow: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			gap: 40,
			width: "100%",
		},
		title: {
			lineHeight: "40px",
		},
		descriptionRow: {
			display: "flex",
			alignItems: "center",
			width: "100%",
		},
		description: {
			flex: "1 0 0",
			minWidth: 0,
			color: theme.palette.text.secondary,
		},
		action: {
			flexShrink: 0,
			"& a, & button": pageHeaderLinkStyle(theme),
		},
	} satisfies Record<string, CSSObject>);
